import React from 'react';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import { Container } from './styles';
import { TooltipIcon } from 'assets/icons';
import moment from 'moment-timezone';
import { TIME_ZONE } from 'constants/constant';

const TransactionTooltip = ({
  warning,
  isVoided,
  createdAt,
  status,
  amount,
  originator,
  cardNumber,
  description,
  voidedAt,
  voidOriginator,
  voidDescription
}) => {

  return (
    <>
      <style>
        {`
          .rc-tooltip-placement-right > .rc-tooltip-arrow {
            top: calc(50% - 11px) !important;  
          }
          .rc-tooltip-placement-right > .rc-tooltip-arrow::before {
            top: -16.5px;
          } 
        `}
      </style>
    <Tooltip
      placement="right"
      trigger={['hover']}
      overlay={
        <Container>
          <div className="item">
            <span className='itemTitle'>Date: </span>
            <span className='createdAt'>
              {moment(createdAt).tz(TIME_ZONE).format('MMM Do YYYY h:mm A')}
            </span>
          </div>
          <div className="item">
            <span className='itemTitle'>Status: </span>
            <span className={"status " + status?.toLowerCase()}>
              {status}
            </span>
          </div>
          <div className="item">
            <span className='itemTitle'>Amount: </span>
            <span className={"amount"+ (warning? " highlight": "")}>{amount}</span>
          </div>
          <div className="item">
            <span className='itemTitle'>Card: </span>
            <span className="cardNumber"> {'XXXX XXXX XXXX ' + cardNumber}</span>
          </div>
          <div className="item">
            <span className='itemTitle'>Originator: </span>
            <span className="originator">{originator}</span>
          </div>
          <div className="item">
            <span className='itemTitle'>Details: </span>
            <span className="description">{description}</span>
          </div>
          {isVoided && (
            <>
              <div className="item">
                <span className='itemTitle'>Voided At: </span>
                <span className='voidedAt'>
                  {moment(voidedAt).tz(TIME_ZONE).format('MMM Do YYYY h:mm A')}
                </span>
              </div>
              <div className="item">
                <span className='itemTitle'>Void Originator: </span>
                <span className="voidOriginator">{voidOriginator}</span>
              </div>
              <div className="item">
                <span className='itemTitle'>Void Description: </span>
                <span className="voidDescription">{voidDescription}</span>
              </div>
            </>
          )}
        </Container>
      }
    >
      <TooltipIcon />
    </Tooltip>
    </>
  );
}

export default TransactionTooltip;
